import './App.css';
import Home from './pages/Home';

function App() {
  return (
    <div className="App bg-[#FFF8EC] min-h-screen text-[#2C3E50]">
      <Home />
    </div>
  );
}

export default App;
